module.exports = __webpack_public_path__ + "revicons.2feb69ccb596730c7292.eot";


//////////////////
// WEBPACK FOOTER
// C:/Users/TerrellDavis/Documents/GitHub/AVL/realavl/realavl/src/assets/js/revolution/fonts/revicons/revicons.eot?5510888
// module id = ../../../../../src/assets/js/revolution/fonts/revicons/revicons.eot?5510888
// module chunks = styles